import { useGetUsersEngagementQuery } from '@/store/api/userApi';

export const useCompanyEngagement = (companyId: string) => {
  const {
    data: engagement,
    isLoading: isEngagementLoading,
    refetch: refetchEngagement,
    error: engagementError,
  } = useGetUsersEngagementQuery(
    { companyId },
    {
      skip: !companyId,
    },
  );

  return {
    engagement,
    engagementError,
    isEngagementLoading,
    refetchEngagement,
  };
};
